module.exports = __webpack_public_path__ + "static/media/skill3.c6454e36.jpeg";